/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';

import Icon, { IconProps } from './index';

const CheckboxChecked: React.FunctionComponent<IconProps> = props => (
	<Icon
		{...props}
		d="M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	/>
);

export default CheckboxChecked;
